<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="picker mResult">
      <van-field :label="field.options.label" :required="field.options.required" readonly clickable :value="fieldValue"
        :placeholder="field.options.placeholder" @click="showPopup" :input-align="field.options.textAlign" />
      <van-popup v-model="show" round position="bottom">
        <van-cascader ref="cascader" title="请选择所在地区" v-model="cascaderValue" :options="options" :field-names="fieldNames"
          @change="changeArea" :closeable="false" active-color="#ff87aa">
          <template slot="title">
            <div class="title">
              <label>所在地区</label>
              <div class="confirm" @click="confirm">确定</div>
            </div>
          </template>
          <!-- 自定义选项内容 -->
          <template v-slot:option="{ option, selected }">
            <div class="custom-option">
              <label>{{ option.label }}</label>
            </div>
            <van-checkbox v-model="selected"></van-checkbox>

          </template>
        </van-cascader>

      </van-popup>
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import request from "@/utils/request";
import { isNull } from "@/utils/util";

export default {
  name: "h5AddressWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
      fieldValue: '',
      cascaderValue: '',
      selectedOptions: [],
      oldOptions: [],
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [],
      fieldNames: {
        text: 'label',
        value: 'value',
        children: 'children',
      },
      fieldModel: "",
      rules: [],
      label: '',
      rulesMsg: {
        '1': '请选择地址到省一级',
        '2': '请选择地址到市一级',
        '3': '请选择地址到区县一级',
        '4': '请选择地址到乡镇一级',
        '5': '请选择地址到村一级',
      }
    };
  },
  components: {
    FormItemWrapper,
  },
  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initEventHandler();

    this.buildFieldRules();
    if (this.field.options.required) {
      this.rulesF();
    }
    this.addOtherRuls()
    this.$nextTick(async () => {
      this.options = await this.getAreaList("");
      this.init(this.field.options.defaultValue)
      this.fieldModel = this.regionArray(this.field.options.defaultValue)
    })
  },

  computed: {
    cascaderRef() {
      return this.$refs.cascader
    }
  },
  watch: {
    fieldModel: {
      handler: function (newVal) {
        let val = newVal || []
        if (Object?.prototype?.toString?.apply(val) !== "[object Array]") {
          val = newVal.split(',')
          this.setValue(val);
          return
        }
        if (this.options.toString() !== val.toString()) {
          this.init(val);
        }
      },
      deep: true
    },
  },
  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    //初始化数据
    async init(newVal) {
      const realAreaCode = this.regionArray(newVal)
      const value = newVal[newVal.length - 1]

      this.cascaderValue = value
      if (realAreaCode.length > 3) {
        let fourOptions = await this.getAreaList(realAreaCode[2]);
        if (realAreaCode.length > 4) {
          for (const item of fourOptions) {
            if (item.value === realAreaCode[3]) {
              item.children = await this.getAreaList(realAreaCode[3]);
            }
          }
        }
        this.getItemChildren(this.options, realAreaCode[2], fourOptions);
      }
      this.label = ''
      this.getLabel(this.options, realAreaCode)
      this.fieldValue = this.label.slice(0, -1)
    },
    // 获取默认值
    getLabel(options, realAreaCode) {
      for (let i = 0; i < options.length; i++) {
        if (realAreaCode.indexOf(options[i].value) > -1) {
          this.label += options[i].label + '-'
        }
        if (options[i].children && options[i].children.length > 0) {
          this.getLabel(options[i].children, realAreaCode)
        }
      }
    },
    showPopup() {
      this.cascaderValue = this.fieldModel[this.fieldModel.length - 1]
      this.show = true
      if (!this.fieldModel) return
      this.$nextTick(() => {
        // 初始化时只显示到选中的当前层级
        const tabs = this.$refs.cascader.tabs

        !tabs[tabs.length - 1].selectedOption && tabs.pop()
        this.selectedOptions = tabs.map(e => {
          return e.selectedOption
        })
        const oTab = this.$refs.cascader.$el.getElementsByClassName('van-tabs__nav--line')[0]
        oTab.addEventListener('click', this.clickTab)

        // 选中值超出屏幕 则自动定位到选中元素
        this.$nextTick(() => {
          const wrapDom = this.$refs.cascader.$el.getElementsByClassName('van-cascader__options')[0]
          const activeDom = this.$refs.cascader.$el.getElementsByClassName('van-cascader__option--selected')[0]
          wrapDom.scrollTop = (activeDom.offsetTop > wrapDom.offsetHeight) ? activeDom.offsetTop : 0
        })
        this.getSelectValue()
      })
    },
    async changeArea({ value, selectedOptions, tabIndex }) {
      this.selectedOptions = selectedOptions
      if (tabIndex > 1 && tabIndex < 4) {
        let fourOptions = await this.getAreaList(value);
        if (fourOptions.length == 0) {
          return
        }
        this.getItemChildren(this.options, value, fourOptions)
      }
    },
    getItemChildren(childrenData, value, fourOptions) {
      if (childrenData.length > 0) {
        childrenData.forEach((childrenItem) => {
          if (childrenItem.value === value) {
            childrenItem.children = fourOptions;
          } else {
            if (childrenItem.children) {
              this.getItemChildren(
                childrenItem.children,
                value,
                fourOptions
              );
            }
          }
        });
      }
    },
    async getAreaList(parentId) {
      // 获取地址列表
      return new Promise((resolve) => {
        if(window.apiConfig.key!='baoan'){
          this.$http({
            url: this.$http.adornUrl("/ntApi/handleRequest"), // 孕保系统固定请求此地址
            data: this.$http.adornData({
              uri: this.field.options.url + parentId || "", // 实际请求的外部系统api路径
              type: "get",
              hideLoading: true,
            }),
          }).then((response) => {
            const { code, data } = response.data;
            resolve(code === 0 ? data : []);
          });

        }else{
          this.$http({
            url: `/jumper-mih/${this.field.options.url + parentId || ""}`,
            method: 'post',
          }).then((response) => {
            const { code, data } = response.data;
            resolve(code === 0 ? data : []);
          });

        }


      })
    },
    getSelectValue() {

      let code = "";
      let text = "";
      this.selectedOptions.forEach((e) => {
        if (e && e.value) {
          text += e.label + "-";
          code += e.value + ",";
        }
      });
      this.fieldModel = code.slice(0, -1);
      this.fieldValue = text.slice(0, -1);
    },
    confirm() {
      this.getSelectValue()
      this.dispatch("ElFormItem", "el.form.change", [this.fieldModel]);
      this.handleChangeEvent(this.fieldModel);
      this.show = false;

    },
    addOtherRuls() {
      this.addruls_();
    },
    addruls_() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback) {
          //空值不校验
          if (isNull(value)) {
            callback();
            return;
          }
          if (_this.fieldModel.length < _this.field.options.addressLv) {
            // 3 县  4 乡 5 村
            let errTxt = _this.rulesMsg[_this.field.options.addressLv];
            callback(new Error(errTxt));
          } else {
            callback();
          }
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
    rulesF() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (_this.fieldModel.length < _this.field.options.addressLv) {
            // 3 县  4 乡 5 村
            let errTxt = _this.rulesMsg[_this.field.options.addressLv];
            callback(new Error(errTxt));
            return;
          }
          if (isNull(value)) {
            callback(new Error("123"));
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
    // 判断数据类型
    regionArray(codes) {
      if (Object?.prototype?.toString?.apply(codes) === "[object Array]") {
        return codes
      } else if (
        Object?.prototype?.toString?.apply(codes) === "[object String]" &&
        codes.length > 0
      ) {
        const regionsTemp = codes.split(",");
        return regionsTemp
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

::v-deep .van-cascader__title {
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .confirm {
    color: #fff;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 14px;
    cursor: pointer;
    background: #ff87aa;
  }
}

::v-deep .van-cascader__selected-icon {
  display: none;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #ff87aa;
  border-color: #ff87aa;
}
</style>
